import React, { useState, useEffect, useContext,useRef  } from "react";
import {
  Box,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {ThemeProvider} from "@mui/material/styles";
import { Badge } from "@mui/material";
import { getNotificationByEmail } from "../../slices/notificationSlice";
import baseUrl from "../../slices/baseUrl";
import { getNotificationCountByEmailId } from "../../slices/notificationSlice";
import BellIcon from "../../images/icons/bellIcon.png";
import { TitleContext } from "./TitleContext";
import { useTheme } from "@mui/material/styles";
import ThemeToggle from "./ThemeToggle";
import { useThemeContext } from "./ThemeContext";
import Notifications from "./Notifications/Notifications";


const Topbar = (props) => {
  const userId = sessionStorage?.getItem("userId");
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const email = sessionStorage?.getItem("email");
  const notificationBoxRef = useRef(null);
  const [displayNotificationCount, setDisplayNotificationCount] = useState(0);
  const togglePopup = () => {
    setIsOpen((prevState) => !prevState);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the notification box is open and the click is outside the box
      const isClickInsideModal = !!event.target.closest('.MuiModal-root');
      if (isOpen && notificationBoxRef.current && !notificationBoxRef.current.contains(event.target) && !isClickInsideModal) {
        setIsOpen(false); // Close the notification box
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  const { title } = useContext(TitleContext);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm"));

  let notificationCount = useSelector(
    (state) => state?.notification?.notificationCount
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (userId > 0) {
        dispatch(getNotificationCountByEmailId(email));
      }
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    dispatch(getNotificationCountByEmailId(email));
  }, [email]);

  useEffect(() => {
    if (notificationCount > 0) {
      setDisplayNotificationCount(notificationCount);
    }
  }, [notificationCount]);

  useEffect(() => {
    setDisplayNotificationCount((prevValue) => (prevValue = 0));
  }, [isOpen]);


  return (
    <Box
      display="flex"
      justifyContent="space-between"
      flexDirection="row"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        backdropFilter: 'blur(12px)',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(10, 15, 28, 0.8)' : 'rgba(255, 255, 255, 0.8)',
        borderBottom: `1px solid ${theme.palette.divider}`,
        height: "64px",
        px: 3,
        alignItems: "center",
      }}
    >
      <Typography 
        variant="h5"
        sx={{
          fontWeight: 700,
          background: 'linear-gradient(135deg, #22D3EE 0%, #6366F1 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontSize: { xs: '1.25rem', sm: '1.5rem' }
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display:"flex",
          alignItems: "center",
          gap: 1.5,
          justifyContent: "flex-end"
        }}
      >
        <ThemeToggle />
        
        
        {/* Hidden popup for mobile - Removed because Sidebar handles it now 
           But wait, if isLargeScreen is false, we are mobile. 
           Sidebar has the script and div.
           So we don't need it here.
        */}

        {isLargeScreen && (
        <Badge
          badgeContent={displayNotificationCount}
          color="secondary"
          sx={{
            position: 'relative',
            display: "flex",
            zIndex: 1000,
            ml: 1,
            alignItems: "center",
            "& .MuiBadge-badge": {
              color: theme.palette.primary.contrastText,
              backgroundColor: theme.palette.primary.main,
            },
          }}
        >
          <IconButton
            className="notification-container"
            size="large"
            sx={{
              cursor: "pointer",
              color: 'text.primary',
            }}
            onClick={togglePopup}
          >
            <img
              src={BellIcon}
              alt="Notifications"
              style={{ height: "20px", filter: theme.palette.mode === 'light' ? 'invert(1)' : 'none' }}
            />
          </IconButton>
        </Badge>
        )}
      </Box>
      {isOpen && (
        <Box
        ref={notificationBoxRef} 
        sx={{
          position: "absolute",
          top: "70px",
          right: "24px",
          zIndex: 1001,
          backgroundColor: theme.palette.mode === 'dark' ? "rgba(10, 15, 28, 0.95)" : theme.palette.background.paper,
          backdropFilter: "blur(20px)",
          borderRadius: "16px",
          boxShadow: theme.palette.mode === 'dark' ? "0 20px 40px rgba(0,0,0,0.4)" : "0 10px 25px rgba(0,0,0,0.1)",
          width: "350px",
          border: `1px solid ${theme.palette.divider}`,
          overflow: "hidden"
        }}
      >
        <Notifications embedded={true} />
      </Box>
      )}
    </Box>
  );
};

export default Topbar;
